<template>
  <div class="progress-bar">
    <div class="bar" :style="{ width: `${current / total * 100}%` }"></div>
  </div>
</template>

<script>
export default {
  name: "ProgressBar",
  props: {
    current: {
      type: Number,
      default: 0,
    },
    total: {
      type: Number,
      default: 0,
    }
  }
}
</script>

<style scoped>
.progress-bar {
  background-color: #777777;
  width: 100%;
  height: 4px;
  position: relative;
  margin-bottom: 1rem;
  border-radius: 50px;
}

.bar {
  height: 4px;
  position: absolute;
  left: 0;
  top: 0;
  background-color: #005EAE;
  background-image: linear-gradient(to right, #005EAE, #92d4fc 12.5%,  #92d4fc 12.5%,  #005EAE 25%, #005EAE  25%, #92d4fc 37.5%, #92d4fc37.5%, #005EAE  50%, #005EAE  50%,#92d4fc 62.5%, #92d4fc 62.5%,#005EAE  75%, #005EAE 75%, #92d4fc 87.5%, #92d4fc 87.5%, #005EAE);
  animation: colored 4s infinite linear;
  background-origin: content-box;
  background-size: 200%;
  transition: 0.2s;
}

@keyframes colored {
  from {
    background-position: 0 0;
  }
  to {
    background-position: -200% 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ProgressBar.vue